import { defineNuxtRouteMiddleware, navigateTo } from '#app'
import { toCanonicalSettingsPath } from '@/lib/settingsRoutes'

export default defineNuxtRouteMiddleware((to) => {
  const canonicalPath = toCanonicalSettingsPath(to.path)
  if (!canonicalPath || canonicalPath === to.path) return

  return navigateTo(
    {
      path: canonicalPath,
      query: to.query,
      hash: to.hash,
    },
    { replace: true },
  )
})
